import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { BASE_URL } from '../../config/config';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class SalesService {

  public DASBOARD_URL = BASE_URL.URL;
  private userId: any;

  constructor(private http: HttpClient, private spinnerService: NgxSpinnerService, private route: Router) { }

  getStoreDetails(store_Id: string, monthInterval: string): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/reports/stores/stocks?store_id=${store_Id}&month_interval=${monthInterval}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }).pipe(
      map((res: any) => res),
      tap(() => this.spinnerService.hide()),
      catchError(this.handleError.bind(this))
    );
  }

  getSalesProducts(type: string, store_Id: string ,currentPage: number, from: string, to: string): Observable<any> {
    this.spinnerService.show();
    const param = {
      token: localStorage.getItem('token') 
    };
    return this.http.get(`${this.DASBOARD_URL}/reports/stores/${type}?store_id=${store_Id}&page=${currentPage}${from ? '&from=' + from : ''}${to ? '&to=' + to : ''}`, {
      headers: {
        'Authorization': 'Bearer ' + param.token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this)) 
      );
  }

  downloadSalesRecords(type: string, store_Id: string ): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/reports/stores/${type}?store_id=${store_Id}&download=1`, {
      responseType: 'blob',
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  private handleError(error: any){
    if (error.status === 401) {
      localStorage.clear();
      this.route.navigateByUrl(`/login?redirect_link=${this.route.url}`);
      this.spinnerService.hide();
      return
    }else if(error.status === 422){
      this.spinnerService.hide();
      return throwError(()=> error);
    }
    else{
      console.error('server error:', error);
    }

  }

}
